import { render, staticRenderFns } from "./BottomNavigator.vue?vue&type=template&id=c68bc6f4"
import script from "./BottomNavigator.vue?vue&type=script&lang=js"
export * from "./BottomNavigator.vue?vue&type=script&lang=js"
import style0 from "./BottomNavigator.vue?vue&type=style&index=0&id=c68bc6f4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports